import { Component, EventEmitter, Input, Output } from '@angular/core';
import saveAs from 'file-saver';
import { IdentityUsersService } from 'src/app/services/identityUsers.service';
import { catchError, firstValueFrom, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/services/toast.service';
import { UserOverviewModel } from '../user-overview.model';
@Component({
  selector: 'app-userList',
  templateUrl: './userlist.component.html'
})
export class UserListComponent {

  constructor(private usersService: IdentityUsersService, private toastService: ToastService, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }
  @Input('users') users!: UserOverviewModel[];
  @Input('organisation') organisation!: any;
  @Input('filter') filter: string = <string>{};
  @Output('refreshUsers') refreshUsers = new EventEmitter();
  translations = <any>{};
  hover: boolean = false;
  itemsPerPage: number = 10;
  pageSize!: number;
  currentPage: number = 1;
  columnName: string = 'firstName';
  orderBy: string = 'asc';
  descending: boolean = false;
  filterUsers = { count: -1 };
  columns: string[] = ['firstName', 'prefix', 'lastName', 'email'];


  getTranslations() {
    this.translateService.get([
      'General.File.Userlist',
      "Toasts.DownloadTitle",
      "Toasts.DownloadBody",
    ]).subscribe(translation => {
      this.translations.filenameUserList = translation['General.File.Userlist'];
      this.translations.downloadTitle = translation['Toasts.DownloadTitle'];
      this.translations.downloadBody = translation['Toasts.DownloadBody'];
    });
  }

  onPageChanged(pageNum: any): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  changePagesize(num: number): void {
    this.itemsPerPage = num;
  }

  async downloadUserOverview() {
    return firstValueFrom((await this.usersService.downloadUsersOverview(this.organisation.guid)).pipe(
      map((data: any) => {
        this.toastService.showDefault(this.translations.downloadTitle,this.translations.downloadBody);
        this.saveFile(data.body, this.translations.filenameUserList + " " + this.organisation.name + ".csv");
      }),
      catchError(async () => {
        this.toastService.showErrorByKey('Toasts.UserOverviewDownloadError');
      })
    ));
  }

  private saveFile(blobContent: Blob, fileName: string) {
    const blob = new Blob([blobContent], { type: 'text/csv' });
    saveAs(blob, fileName);
  }

  sortData(column: string) {
    if (this.columnName == column) {
      this.descending = !this.descending;
    } else {
      this.columnName = column;
      this.descending = false;
    }
    if (!this.descending) {
      this.orderBy = 'asc';
    } else {
      this.orderBy = 'desc';
    }
  }

  requestRefreshUsers() {
    this.refreshUsers.emit();
  }
}
